import React from "react"
import { connect } from "react-redux"
import Card, { TitleCard } from "../../core/Card"
import Line from "../../core/Line"

import {
  ForwardIcon,
  Icon,
  BriefcaseIcon,
  ReturnOnInvestmentIcon
} from "../../core/icons"
import { BrowserRouter as Router, Route, Link } from "react-router-dom"
import {
  Slider,
  Select,
  Button,
  Col,
  Row,
  Popover,
  Icon as AIcon,
  Switch
} from "antd"
import { push } from "react-router-redux"

// import New from './New'
// import Update from './Update'
import EmptyState from "../../core/components/EmptyState"
import twix from "twix"
import moment from "moment"
import toReadableString from "./toReadableString"
import {
  amountToExpenseOrRevenue,
  getCombinedPurpose,
  accountsFromInstitutionUsers
} from "./"

const FaveTxnLine = connect((state, ownProps) => {
  const institutionUsers = state.models.user.institution_users
  const conditions = ownProps.rules.map(r => amountToExpenseOrRevenue(r))

  const bankCondition = ownProps.rules.find(
    ({ observed_field }) => observed_field == "institution_account_token_id"
  )

  const bankName = {
    displayName: "(unlinked bank account)",
    ...(bankCondition
      ? accountsFromInstitutionUsers(institutionUsers).find(
          account =>
            account.institution_account_token_id == bankCondition.enforced_value
        )
      : { displayName: "" })
  }.displayName
  // <span style={{ color: "#dcd" }}>
  //   {account.institution_name}{" "}
  // </span>{" "}
  // {account.displayName}
  return {
    ruleString: `${toReadableString(conditions)} <b>${bankName}</b>`,
    purposeOrIncome: getCombinedPurpose(ownProps.rule_actions)
  }
})(({ id, dispatch, bankName, purposeOrIncome, ruleString, ...props }) => {
  return (
    <Line onClick={() => dispatch(push(`favorite-transactions/${id}`))}>
      <Col span={1}>
        <ReturnOnInvestmentIcon />
      </Col>
      <Col span={12}>
        {<div dangerouslySetInnerHTML={{ __html: ruleString }} />}
      </Col>
      <Col span={9}>
        {purposeOrIncome && <div>Classify as: {purposeOrIncome}</div>}
        {props.rule_actions.map(
          v =>
            v.enforced_field == "notes" && <div>Notes: {v.enforced_value}</div>
        )}
      </Col>
      <Col span={1}>
        <ForwardIcon />
      </Col>
    </Line>
  )
})

const All = ({ onClick, favorite_transactions }) => (
  <div>
    <TitleCard sticky>
      <h1>Transaction Rules</h1>

      <Link to="/account/favorite-transactions/new">
        <Button type="primary" icon="plus">
          New
        </Button>
      </Link>
    </TitleCard>

    <Card>
      {favorite_transactions.length > 0 ? (
        favorite_transactions.map((props, i) => (
          <FaveTxnLine key={i} {...props} />
        ))
      ) : (
        <EmptyState
          title="No rules created yet."
          // buttonLink="/account/bank-card/new"
          // buttonText="Add Bank or Credit Card"
          // buttonIcon='plus'
          icon={ReturnOnInvestmentIcon}
        />
      )}
    </Card>
  </div>
)

export default All



// WEBPACK FOOTER //
// ./src/account/favorite-transactions/All.js